import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import illustration from '../assets/images/NotFound-cbconnect.svg';

/**
 * Écran affiché pour une adresse qui ne correspond à aucune page (404).
 *
 * L'ILLUSTRATION REMPLACE UN EMOJI. Le classeur 🗂️ dépendait de la police du
 * système : il se rendait différemment d'un poste à l'autre, et pas du tout là où
 * la police manque. Les trois écrans d'état - maintenance, accès refusé, page
 * introuvable - portent désormais la même facture.
 *
 * `alt` vide : l'illustration est décorative, le message est écrit juste dessous.
 */
export default function NotFound() {
  const { t } = useTranslation('commun');
  const navigate = useNavigate();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - var(--cb-banniere-h, 0px))', background: '#f8f9fb', gap: 16 }}>
      <img
        src={illustration}
        alt=""
        style={{ width: '100%', maxWidth: 420, height: 'auto' }}
      />
      <h1 style={{ fontSize: 28, fontWeight: 700, color: '#111827', margin: 0 }}>{t('notFound.titre')}</h1>
      <p style={{ color: '#6b7280', margin: 0 }}>{t('notFound.message')}</p>
      {/* DEUX ISSUES, ET ELLES NE FONT PAS DOUBLON. << Retour >> ramene d'ou l'on
          vient : c'est ce qu'on veut quand on a suivi un lien par erreur. Le tableau
          de bord est l'issue de secours, celle qui marche meme quand l'historique est
          vide - une adresse ouverte directement, un signet, un lien recu. Sans la
          seconde, un arrivant sans historique resterait coince. */}
      <div style={{ display: 'flex', gap: 10, marginTop: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button onClick={() => navigate(-1)} style={{ borderRadius: 8 }}>
          {t('notFound.retour')}
        </Button>
        <Button type="primary" onClick={() => navigate('/dashboard')}
          style={{ background: '#1a6b3c', borderColor: '#1a6b3c', borderRadius: 8 }}>
          {t('notFound.retourTableauDeBord')}
        </Button>
      </div>
    </div>
  );
}
